import {
  TeButton,
  TeContainer,
  TeContainerSlim,
  TeIcon,
  TeModal,
  TeText,
} from '@topcon/tuicl-react';
import styled from 'styled-components';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { IconName } from '@topcon/tuicl/dist/components/icon/icon.utils';

import { background } from '../../providers/theme/theme.index';

interface Props {
  title: string;
  description: string;
  icon: IconName;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

function LimitReachedModal({ title, description, icon, open, setOpen }: Props) {
  const { t } = useTranslation('common');

  return (
    <TeModal
      variant="dark"
      open={open}
      closeMode="overlay"
      teclose={() => {
        setOpen(false);
      }}
      contentPadding={0}
      size="s"
      width="s"
    >
      <TeContainer
        backgroundColor="background.primary"
        padding={['xl', 's']}
        column
        grow
        alignItems="center"
      >
        <IconWrapper>
          <TeIcon size="xl" name={icon} />
        </IconWrapper>
        <TeContainerSlim column alignItems="center" gap="l">
          <TeContainerSlim column alignItems="center" gap="xs2">
            <TeText size={20} weight={700}>
              {title}
            </TeText>
            <TeText size={12} color="text.secondary">
              {description}
            </TeText>
          </TeContainerSlim>
          <TeButton
            text={t('iUnderstand')}
            variant="primary"
            teclick={() => setOpen(false)}
            size="s"
          />
        </TeContainerSlim>
      </TeContainer>
    </TeModal>
  );
}

export default LimitReachedModal;

const IconWrapper = styled.div<{ size?: number }>`
  width: 64px;
  height: 64px;
  background-color: ${background.tertiary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
